<div>
  <div class="columns is-mobile is-centered is-vcentered">
    <div class="column">
      <div class="columns">
        <div class="column is-narrow">
          <img *ngIf="!showAltImage" [src]="flight?.urlIcon" alt="" (error)="showAltImage = true" />
          <div *ngIf="showAltImage" class="no-ico">
            {{ flight?.operatingCarrier?.name?.charAt(0) }}
          </div>
        </div>
        <div class="column px-0">
          <span class="is-capitalized vertical-align has-text-weight-semibold is-size-9">
            {{ flight?.operatingCarrier?.name | lowercase }}</span
          >
          <div class="is-size-7 has-text-grey">
            <span>
              {{ 'itinerary-info.flight.flightEquipment' | translate }}
            </span>
            <em class="mdi mdi-airplane mdi-16px mdi-rotate-90" aria-hidden="true"></em>
            <span>
              {{ flight?.flightEquipment }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="column has-text-centered" [class.has-text-right]="!showBaggage">
      <span class="is-size-7 has-text-grey">
        {{ 'itinerary-info.flight.flight' | lowercase | translate }}
        {{ flight?.number }}
      </span>
    </div>
    <div *ngIf="showBaggage" class="column has-text-right has-text-grey is-size-7">
      <em class="mdi mdi-briefcase mdi-18px"></em>
      <em
        *ngIf="flight?.baggageAllowance >= 2"
        class="mdi mdi-briefcase has-text-grey mdi-14px"
      ></em>
      {{
        'itinerary-info.baggageAllowanceNumber'
          | translate : { size: flight?.baggageAllowance || 0 }
      }}
    </div>
  </div>

  <div class="columns info-box is-mobile is-centered mb-1pt">
    <div class="column has-text-centered">
      <span class="is-size-7 is-block" attr.data-title="{{ flight?.departureDate }}">
        {{ flight?.departureDate | date | localizedDate : 'EEE d MMM' }}
      </span>
      <span class="is-size-5 has-text-weight-normal is-block">
        {{ flight?.departureDate | date : 'HH:mm' }}
      </span>
      <span class="is-size-3 is-uppercase has-text-weight-semibold is-block">
        {{ flight?.departureLocation?.code }}
      </span>
      <span class="is-size-7 is-lowercase is-capitalized is-block less-margin-top">
        {{ flight?.departureLocation?.name }}
      </span>
      <span class="is-size-7 is-block is-capitalized is-block less-margin-top has-text-grey">
        {{ flight?.departureLocation?.airportName | lowercase }}
      </span>
      <span
        *ngIf="flight.departureLocation.terminalName && flight.departureLocation.terminalName != ''"
        class="is-size-7 is-block is-capitalized is-block less-margin-top has-text-grey"
      >
        {{ 'itinerary-info.flight.terminalName' | translate }}:
        {{ flight?.departureLocation?.terminalName | lowercase }}
      </span>
    </div>

    <div class="column has-text-centered">
      <span class="is-size-7">
        {{ 'itinerary-info.flight.state' | translate }}:
        <span class="weight-medium" [class.has-text-warning]="flight?.status === 'rescheduled'">
          {{ flight?.status | firstcase }}
        </span>
      </span>
      <br />
      <span *ngIf="flight?.codeShareOperatingRecordLocator != ''" class="is-size-7">
        {{ 'itinerary-info.flight.codeShared' | translate }}:
        <span class="weight-medium">
          {{ flight?.codeShareOperatingRecordLocator }}
        </span>
      </span>
      <br *ngIf="flight?.codeShareOperatingRecordLocator != ''" />
      <span class="is-size-7">
        {{ 'itinerary-info.flight.web-check-in' | translate }}
      </span>
      <br />
      <br />
      <span *ngIf="flight?.airlineCode" class="is-size-7">
        <span class="is-size-7">
          {{ 'itinerary-info.flight.airlineCode' | translate }}:
          <span class="weight-medium">
            {{ flight?.airlineCode }}
          </span>
        </span>
      </span>
      <br *ngIf="flight?.airlineCode" />
      <span class="is-size-7">
        {{ 'itinerary-info.flight.duration' | translate }}:
        {{ flight?.timeOfFlight | TimeOfFlight }}
      </span>
      <br />
      <span class="is-size-7 is-block">
        {{ 'itinerary-info.flight.cabin' | translate }}:
        {{ flight?.cabin }}
      </span>
      <div *ngIf="isAirline">
        <span class="is-size-7">
          <em class="mdi mdi-briefcase mdi-12px"></em>
          {{
            'itinerary-info.baggageAllowanceNumber'
              | translate : { size: flight?.baggageAllowance || 0 }
          }}
        </span>
      </div>
      <span class="is-size-7 is-block">
        {{ 'itinerary-info.flight.class' | translate }}:
        {{ flight?.classOfService }}

        <span
          class="is-size-7 is-block && no-seats-available"
          *ngIf="!!!flight.availableClasses.length && !validateIsItineraryUrl()"
        >
          {{ 'seats.status.no-available' | translate }}
        </span>

        <section class="field" *ngIf="!!flight.availableClasses.length">
          <div class="control text-center">
            <div class="select is-link">
              <!-- Select a Class -->
              <select
                *ngIf="isAirline"
                [ngModel]="flight?.classOfService"
                [value]="data"
                (ngModelChange)="ChangeValue($event); changeClass.emit($event)"
              >
                <option [disabled]="true" [ngValue]="flight?.classOfService">
                  {{ 'involuntary-change.select-class' | translate }}
                </option>
                <option
                  *ngFor="let item of newAvailableClasses"
                  [value]="item.classOfService"
                  [disabled]="
                    isAirline
                      ? validateClassUpgrade(item.classOfService) ||
                        item.seats < passengerCount ||
                        (item.disabled && isAm)
                      : (item.seats < passengerCount && item.seats < 7) || (item.disabled && isAm)
                  "
                >
                  {{ item.classOfService }} ({{ item.seats }})
                </option>
              </select>
              <!-- Select a Class -->
              <select
                *ngIf="!isAirline"
                [ngModel]="flight.classOfService"
                (ngModelChange)="flight.classOfService = $event; changeClass.emit($event)"
              >
                <option selected disabled>
                  {{ 'involuntary-change.select-class' | translate }}
                </option>
                <option
                  *ngFor="let item of flight.availableClasses"
                  [value]="item.classOfService"
                  [disabled]="item.seats < passengerCount"
                >
                  {{ item.classOfService }} ({{ item.seats }})
                </option>
              </select>
            </div>
          </div>
        </section>
      </span>

      <div class="v-separator"></div>

      <!-- More Info flight -->
      <div *ngIf="additionalFlightInfo" class="columns">
        <div class="column">
          <button
            *ngIf="isAirline && flightHasSRequest && isValidProccessToSRVerification"
            class="button is-link is-outlined mb-1"
            (click)="launchAncillariesVerificationModal()"
          >
            {{ 'itinerary-info.flight.special-request-verification' | translate }}
          </button>

          <button class="button is-link is-outlined" (click)="flightInfoPopUp()">
            {{ 'itinerary-info.flight.flightInfo' | translate }}
          </button>
        </div>
      </div>
      <!-- More Info flight -->
    </div>
    <div class="column has-text-centered">
      <span
        class="is-size-7 is-block"
        [class.has-text-danger]="flight?.daysDifference > 0"
        attr.data-title="{{ flight?.arrivalDate }}"
      >
        <span *ngIf="flight?.daysDifference > 0" class="is-size-7 has-text-danger">
          (+{{ flight?.daysDifference }})
        </span>
        {{ flight?.arrivalDate | date | localizedDate : 'EEE d MMM' }}
      </span>
      <span class="is-size-5-widescreen has-text-weight-normal is-block">
        {{ flight?.arrivalDate | date : 'HH:mm' }}
      </span>
      <span class="is-size-3 is-uppercase has-text-weight-semibold is-block">
        {{ flight?.arrivalLocation?.code }}
      </span>
      <span class="is-size-7 is-lowercase is-capitalized is-block less-margin-top">
        {{ flight?.arrivalLocation?.name }}
      </span>
      <span class="is-size-7 is-block is-capitalized is-block less-margin-top has-text-grey">
        {{ flight?.arrivalLocation?.airportName | lowercase }}
      </span>
      <span
        *ngIf="flight.arrivalLocation.terminalName && flight.arrivalLocation.terminalName != ''"
        class="is-size-7 is-block is-capitalized is-block less-margin-top has-text-grey"
      >
        {{ 'itinerary-info.flight.terminalName' | translate }}:
        {{ flight?.arrivalLocation?.terminalName | lowercase }}
      </span>
    </div>
  </div>
</div>

<!-- Modal SRequest verification -->
<app-modal
  [isActive]="openSRequestValidationModal"
  (modalState)="openSRequestValidationModal = false"
>
  <p class="modal-card-title" modal-title>
    <em class="mdi mdi-message-alert has-text-warning mdi-18px" aria-hidden="true"></em
    >{{ 'itinerary-info.flight.special-request-compatibility-verification' | translate }}
  </p>

  <div modal-content>
    <div class="column has-text-centered">
      <div *ngFor="let passenger of pnrInfo.passengers">
        <div *ngFor="let specialRequest of passenger.specialRequests">
          <div *ngIf="specialRequest?.coupons?.length <= 0">
            <app-flight-special-requests
              [specialRequest]="specialRequest"
              [showSRequestValidation]="true"
              [sRequestValidationReady]="sRequestValidationReady"
              [sRequestValidationError]="sRequestValidationError | async"
              [isCompatible]="verifyIfIsCompatible(specialRequest.code)"
              type="specialRequest"
            ></app-flight-special-requests>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-modal>
<!-- Modal SRequest verification -->

<!-- Modal Flight info -->
<app-modal
  [isActive]="openAditionalInformationModal"
  (modalState)="additionalInformationModalState($event)"
>
  <p class="modal-card-title" modal-title>
    <em class="mdi mdi-information-outline has-text-success mdi-18px" aria-hidden="true"></em>
    {{ 'itinerary-info.flight.flightInfo' | translate }}
  </p>

  <div modal-content>
    <div class="row modal-info">
      <div class="column">
        <span *ngIf="!moreInfoFligth" class="is-size-12">
          {{ 'itinerary-info.flight.flight' | lowercase | translate }}:
          {{ flight?.number || 'N/A' }}
        </span>

        <span *ngIf="moreInfoFligth" class="is-size-12">
          {{ 'itinerary-info.flight.flight' | lowercase | translate }}:
          {{ infoFligth?.opertingCarrier.flightNumber || 'N/A' }}
        </span>
      </div>

      <div class="column">
        <span *ngIf="!moreInfoFligth" class="is-size-12">
          {{ 'itinerary-info.flight.numberFlightValidatingCarrier' | translate }}:
          {{ flight?.numberFlightValidatingCarrier || 'N/A' }}
        </span>

        <span *ngIf="moreInfoFligth" class="is-size-12">
          {{ 'itinerary-info.flight.numberFlightValidatingCarrier' | translate }}:
          {{ infoFligth?.marketingCarrier.flightNumber || 'N/A' }}
        </span>
      </div>
    </div>
    <div class="row modal-info">
      <div class="column">
        <span class="is-size-12">
          {{ 'itinerary-info.flight.stopOvers' | translate }}:
          {{ flight?.stopOvers || 'N/A' }}
        </span>
      </div>
      <div class="column">
        <span class="is-size-12">
          <em class="mdi mdi-plus mdi-16px" aria-hidden="true"></em>
          {{ 'itinerary-info.flight.flightMilleage' | translate }}:
          {{
            flight?.flightMilleage != null
              ? flight?.flightMilleage
              : infoFligth?.flightMilleage || 'N/A'
          }}
        </span>
      </div>
    </div>
  </div>
</app-modal>
<!-- Modal Flight info -->
